import styled from 'styled-components/macro';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
`;

export const Loader = styled.div`
  min-height: 300px;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const TableWrapper = styled.div`
  margin-bottom: 100px;
  table {
    thead {
      tr {
        th {
          padding: 5px 10px 10px 10px;
        }
      }
    }
    th {
      & > button {
        display: none;
      }
      &:nth-child(3) {
        white-space: nowrap;
      }
    }
    td {
      &:nth-child(6),
      &:nth-child(5),
      &:nth-child(4) {
        white-space: nowrap;
        padding: 0 5px;
      }
    }
  }
`;
